import React from 'react';
import { FaCheck, FaPen, FaPlay, FaStop, FaTimes } from 'react-icons/fa';

import './style.css';
import ReactTooltip from 'react-tooltip';

class Estimulos extends React.Component {
  audio = null;

  constructor(props) {
    super(props);

    this.state = {
      playing: false,
      is_verified: this.props.is_verified,
    };

    this.play = this.play.bind(this);
    this.stop = this.stop.bind(this);

    this.audio = new Audio(this.props.audio);
  }

  componentDidMount() {
    this.audio.addEventListener('ended', () =>
      this.setState({ playing: false }),
    );

    this.props.onRef(this);
  }

  componentWillUnmount() {
    this.audio.pause();
    this.audio.currentTime = 0;

    this.audio.removeEventListener('ended', () =>
      this.setState({ playing: false }),
    );

    this.props.onRef(undefined);
  }

  play() {
    console.log('TOCA!');

    if (this.state.playing) {
      this.setState({
        playing: false,
      });

      this.audio.pause();
      this.audio.currentTime = 0;
    } else {
      this.setState({
        playing: true,
      });

      this.audio.play();
    }
  }

  stop() {
    this.setState({
      playing: false,
    });

    this.audio.pause();
    this.audio.currentTime = 0;
  }

  changeVerify(is_verified) {
    this.setState({
      is_verified: is_verified,
    });
  }

  render() {
    return (
      <div
        className={`estimulo${this.props.cor !== undefined ? ' estimulo-3' : ''} ${this.props.status === 'processado' && this.props.score === 0 ? 'processando' : this.props.status}`}
      >
        <div className="nome-estimulo">{this.props.nome}</div>
        {this.props.cor !== undefined ? (
          <div className="nome-cor">{this.props.cor}</div>
        ) : null}
        <div className="score-estimulo">{this.props.score}</div>
        <div className="tr-estimulo">
          {this.props.score === 1
            ? this.props.tr.toLocaleString('pt-BR', {
                maximumFractionDigits: 3,
              })
            : '-'}
        </div>
        <div className="status">{this.props.status}</div>

        {this.props.status === 'processando' ||
        this.props.status === 'em processamento' ? null : (
          <>
            <div
              className={`validar-estimulo ${this.props.is_verified ? 'validada' : 'nao-validada'}`}
            >
              {this.props.is_verified ? 'Sim' : 'Não'}
              {/* <div
                className={`verify-estimulo ${this.state.is_verified ? 'verify-estimulo-checked' : 'verify-estimulo-unchecked'}`}
                onClick={this.props.verify}
                data-tip={
                  this.props.is_verified
                    ? 'Desmarcar verificação'
                    : 'Verificar resposta'
                }
                data-for={`tooltip-estimulo-${this.props.id_resposta}`}
                onMouseEnter={() => this.changeVerify(!this.props.is_verified)}
                onMouseLeave={() => this.changeVerify(this.props.is_verified)}
              >
                {this.state.is_verified ? <FaCheck /> : <FaTimes />}
              </div>
              <ReactTooltip
                id={`tooltip-estimulo-${this.props.id_resposta}`}
                place="top"
                effect="solid"
              /> */}
            </div>
            <div className="acoes-estimulo">
              {this.props.edit ? (
                <div
                  className="edit-estimulo"
                  onClick={this.props.edit}
                  data-tip="Editar resposta"
                  data-for={`tooltip-estimulo-${this.props.id_resposta}`}
                >
                  <FaPen />
                </div>
              ) : null}
              <div
                className="play-estimulo"
                onClick={this.props.play}
                data-tip="Reproduzir áudio"
                data-for={`tooltip-estimulo-${this.props.id_resposta}`}
              >
                {this.state.playing ? <FaStop /> : <FaPlay />}
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}

export default Estimulos;
